var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"alert"},[_c('p',[_vm._v(_vm._s(_vm.message)),_c('br'),_c('br'),_vm._v("We apologize for the inconvenience")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }